import React from "react";
import { Link } from "react-router-dom";
import "./VehicleListCard.css";
import { useTranslation } from "react-i18next";

export default function VehicleListCard({ vehicle }) {
  const { t } = useTranslation();

  const {
    titleKey,
    imageSrc,
    href,
    shortDescriptionKey,
    price,
    engine,
    payload
  } = vehicle;

  return (
    <article className="vehicle-list-card">
      <div className="vehicle-list-card__left">
        <h2 className="vehicle-list-card__name">{t(titleKey)}</h2>

        {shortDescriptionKey && (
          <p className="vehicle-list-card__desc">{t(shortDescriptionKey)}</p>
        )}

          <p className="price-start-head">Starting From</p>

        {price && (
          <div className="vehicle-list-card__price mb-0">
            <span className="vehicle-list-card__price-value">{price}</span>
          </div>
        )}

        <h6 className="vat-highlight mb-2">{t("vehiclesPage.exclusiveVat")}</h6>

        {(engine || payload) && (
          <div className="vehicle-list-card__features">
            {engine && (
              <div className="vehicle-list-card__feature">
                <span className="vehicle-list-card__feature-label">
                  {t("vehiclesPage.engineLabel")}
                </span>
                <span className="vehicle-list-card__feature-value">{engine}</span>
              </div>
            )}

            {payload && (
              <div className="vehicle-list-card__feature">
                <span className="vehicle-list-card__feature-label">
                  {t("vehiclesPage.payloadLabel")}
                </span>
                <span className="vehicle-list-card__feature-value">{payload}</span>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="vehicle-list-card__right">
        <div className="vehicle-list-card__image-wrapper">
          <img
            src={imageSrc}
            alt={t(titleKey)}
            className="vehicle-list-card__image"
          />
        </div>

        <div className="vehicle-list-card__actions">
          <Link to={href || "#"} className="lk-brand-link">
            {t("vehiclesPage.viewDetails")} →
          </Link>
        </div>
      </div>
    </article>
  );
}